interface SeoHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
  };
}

export default function SeoHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  articleData,
}: SeoHeadProps) {
  const fullTitle = title.includes("夫妻影院")
    ? title
    : `${title} - 夫妻影院`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="夫妻影院" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:width" content="1200" />}
      {ogImage && <meta property="og:image:height" content="630" />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {articleData?.publishedTime && (
        <meta
          property="article:published_time"
          content={articleData.publishedTime}
        />
      )}
      {articleData?.modifiedTime && (
        <meta
          property="article:modified_time"
          content={articleData.modifiedTime}
        />
      )}
      {articleData?.author && (
        <meta property="article:author" content={articleData.author} />
      )}
    </>
  );
}